module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-8-4ee8a559fde90ac5bfaa7b7356e07b81.svg";